export const METRIC_COLORS = {
  recovery: {
    base: 'text-success',
    bg: 'bg-success/10',
    ring: 'stroke-success'
  },
  strain: {
    base: 'text-primary',
    bg: 'bg-primary/10',
    ring: 'stroke-primary'
  },
  sleep: {
    base: 'text-purple-500',
    bg: 'bg-purple-500/10',
    ring: 'stroke-purple-500'
  },
  hrv: {
    base: 'text-cyan-500',
    bg: 'bg-cyan-500/10',
    ring: 'stroke-cyan-500'
  }
} as const;

export const METRIC_POSITIONS = {
  'left-top': '-translate-x-full -translate-y-1/2 left-0 top-1/4',
  'left-bottom': '-translate-x-full -translate-y-1/2 left-0 top-3/4',
  'right-top': 'translate-x-full -translate-y-1/2 right-0 top-1/4',
  'right-bottom': 'translate-x-full -translate-y-1/2 right-0 top-3/4'
} as const;

export type MetricPosition = keyof typeof METRIC_POSITIONS;
export type MetricColorScheme = keyof typeof METRIC_COLORS;